module.exports = __webpack_public_path__ + "static/media/accessories.b6233a89.jpeg";